/**
 * AdvertisingPlatform
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * OpenAPI spec version: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { V1DataSource } from '../models/V1DataSource';
import { HttpFile } from '../http/http';

/**
* Upcharge contains the breakdown of the cpm plus by upcharge.
*/
export class V1Upcharge {
    /**
    * NOTE(morgan): https://github.com/googleapis/googleapis/blob/master/google/type/money.proto The three-letter currency code defined in ISO 4217.
    */
    'currencyCode'?: string;
    /**
    * The whole units of the amount. For example if `currencyCode` is `\"USD\"`, then 1 unit is one US dollar.
    */
    'units'?: string;
    /**
    * Number of nano (10^-9) units of the amount. The value must be between -999,999,999 and +999,999,999 inclusive. If `units` is positive, `nanos` must be positive or zero. If `units` is zero, `nanos` can be positive, zero, or negative. If `units` is negative, `nanos` must be negative or zero. For example $-1.75 is represented as `units`=-1 and `nanos`=-750,000,000.
    */
    'nanos'?: number;
    'dataSource'?: V1DataSource;

    static readonly discriminator: string | undefined = undefined;

    static readonly attributeTypeMap: Array<{name: string, baseName: string, type: string, format: string}> = [
        {
            "name": "currencyCode",
            "baseName": "currency_code",
            "type": "string",
            "format": ""
        },
        {
            "name": "units",
            "baseName": "units",
            "type": "string",
            "format": "int64"
        },
        {
            "name": "nanos",
            "baseName": "nanos",
            "type": "number",
            "format": "int32"
        },
        {
            "name": "dataSource",
            "baseName": "data_source",
            "type": "V1DataSource",
            "format": ""
        }    ];

    static getAttributeTypeMap() {
        return V1Upcharge.attributeTypeMap;
    }

    public constructor() {
    }
}

